






























































































































































































































































































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormFile,
  VBTooltip,
  BFormTextarea
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { Contrat, UpdateContratModel } from "@/api/models/contrats/contrat";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { ShortOpportunite } from "@/api/models/opportunites/opportunite";
import { Contact } from "@/api/models/contacts/contact";
import { AdvancedContrat } from "@/api/models/contrats/advancedContrat";
import { Partenaire } from "@/api/models/partenaires/partenaire";
import { Fournisseur } from "@/api/models/fournisseurs/fournisseur";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormDatepicker,
    BFormFile,
    BFormTextarea
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  name: "update-contrat",
})
export default class EditAdvancedContrat extends Vue {
  @Prop({ required: true, type: Boolean })
  isUpdateContratSidebarActive!: boolean;

  @Prop({ required: true, type: String })
  contratId!: string;

  loading = false;
  required = required;
  loadingContact = false;

  listTypeContrat = [];
  totalCountTypeContrat = 0;

  contrat: Partial<AdvancedContrat> = {};

  paginatedListUsers: PaginatedList<ShortUtilisateur> = new PaginatedList<ShortUtilisateur>();
  paginatedListOpportunites: PaginatedList<ShortOpportunite> = new PaginatedList<ShortOpportunite>();
  paginatedListContactsComptabilite: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListPartenaires: PaginatedList<Partenaire> = new PaginatedList<Partenaire>();
  paginatedListFournisseurs: PaginatedList<Fournisseur> = new PaginatedList<Fournisseur>();

  listEcheancierFacturation: { code: string; libelle: string; }[] = [];
  listConditionPaiement: { code: string; libelle: string; }[] = [];
  listEntiteFacturation: { code: string; libelle: string; }[] = [];
  listTypePrestation: { code: string; libelle: string; }[] = [];

  canQualiopi = false
  mappingsNatureOffreTypeContrat: { source: string; destination: string; canQualiopi: boolean }[] = []

  refreshIndex = 0

  get canUpdateContrat() {
    return this.$can('ENTREPRISES_CONTRATSV2:admin');
  }

  async created() {
    await this.getTypeContrat();
    await this.loadEcheancierFacturation();
    await this.loadConditionPaiement();
    await this.loadEntiteFacturation();
    await this.loadTypePrestation();
    await this.loadAdvancedContrat();
    await this.loadMapping();
  }

  resetForm() {
    this.contrat = {};
  }

  typeContratChanged(value: string) {
    this.canQualiopi = this.mappingsNatureOffreTypeContrat.find(m => m.destination === value)?.canQualiopi ?? false;
    this.refreshIndex++;
  }

  async loadMapping() {
    const param = await this.$http.myressif.parametres.getByNom("mapping_natureOffre_typeContrat");
    this.mappingsNatureOffreTypeContrat = JSON.parse(param.valeur);
    this.typeContratChanged(this.contrat.typeContrat!);
  }

  @Watch("contratId")
  async loadAdvancedContrat() {
    await this.$http.myressif.entreprises
      .getAdvancedContratById(this.$route.params.id, this.contratId)
      .then((res: AdvancedContrat) => {
        this.contrat = res;
        this.loadingContact = true;
        
        if (res.responsableId && res.responsableCompleteNom) {
          const nameParts = res.responsableCompleteNom.split(' ')
          const nom = nameParts[0] || ''
          const prenom = nameParts.slice(1).join(' ') || ''
          
          this.paginatedListUsers.items.unshift({
            id: res.responsableId,
            nom: nom,
            prenom: prenom,
            completeLabel: res.responsableCompleteNom
          } as any)
          this.paginatedListUsers.totalCount++
        }

        if (res.opportuniteId && res.opportuniteLibelle) {
          this.paginatedListOpportunites.items.unshift({
            id: res.opportuniteId,
            libelle: res.opportuniteLibelle
          } as any)
          this.paginatedListOpportunites.totalCount++
        }

        if (res.contactComptabiliteId && res.contactComptabiliteCompleteNom) {
          this.paginatedListContactsComptabilite.items.unshift({
            id: res.contactComptabiliteId,
            completeNom: res.contactComptabiliteCompleteNom
          } as AdvancedContrat)
          this.paginatedListContactsComptabilite.totalCount++
        }

        if (res.partenaireId && res.partenaireNom) {
          const partenaireExists = this.paginatedListPartenaires.items.some(c => c.id === res.partenaireId)
          if (!partenaireExists) {
            this.paginatedListPartenaires.items.unshift({
              id: res.partenaireId,
              nom: res.partenaireNom
            } as Partenaire)
            this.paginatedListPartenaires.totalCount++
          }
        }

        if (res.fournisseurId && res.fournisseurNom) {
          const fournisseurExists = this.paginatedListFournisseurs.items.some(c => c.id === res.fournisseurId)
          if (!fournisseurExists) {
            this.paginatedListFournisseurs.items.unshift({
              id: res.fournisseurId,
              nom: res.fournisseurNom
            } as Fournisseur)
            this.paginatedListFournisseurs.totalCount++
          }
        }

        if (res.responsableId && res.responsableCompleteNom) {
        const responsableExists = this.paginatedListUsers.items.some(u => u.id === res.responsableId)
        if (!responsableExists) {
          const nameParts = res.responsableCompleteNom.split(' ')
          const nom = nameParts[0] || ''
          const prenom = nameParts.slice(1).join(' ') || ''
          
          this.paginatedListUsers.items.unshift({
            id: res.responsableId,
            nom: nom,
            prenom: prenom,
            completeLabel: res.responsableCompleteNom
          } as any)
          this.paginatedListUsers.totalCount++
        }
      }
    });
    this.refreshIndex++;
  }

  async getTypeContrat() {
    await this.$http.myressif.parametres
      .getByNom("type_advanced_contrat_adherent")
      .then((res: any) => {
        this.listTypeContrat = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .updateAdvancedContratEntreprise(
        this.$route.params.id,
        this.contrat.id,
        this.contrat
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du contrat",
            text: "Contrat modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-contrat");
        this.$emit("update:is-update-contrat-sidebar-active", false);
        this.loading = false;
      });
  }

  async loadUsers(params: any) {
    if (!params || params?.reset) {
      this.paginatedListUsers.items = this.paginatedListUsers?.items.filter(u => this.contrat.responsableId === u.id);
      this.paginatedListUsers.totalCount = this.paginatedListUsers.items.length;
    }

    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        null,
        null,
        true
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        const mappedItems = response.items.map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        
        this.paginatedListUsers.items = this.paginatedListUsers!.items.concat(
          mappedItems.filter(
            (ri) => !this.paginatedListUsers!.items.some((lsi) => lsi.id == ri.id)
          )
        );
        this.paginatedListUsers.hasNextPage = response.hasNextPage
        this.paginatedListUsers.hasPreviousPage = response.hasPreviousPage
        this.paginatedListUsers.pageIndex = response.pageIndex
        this.paginatedListUsers.totalCount = response.totalCount
        this.paginatedListUsers.totalPages = response.totalPages
      });
  }

  async loadListPartenaires(params: any) {
    if (!params || params?.reset) {
      this.paginatedListPartenaires.items = this.paginatedListPartenaires?.items.filter(u => this.contrat?.partenaireId === u.id);
      this.paginatedListPartenaires.totalCount = this.paginatedListPartenaires.items.length;
    }

    await this.$http.myressif.partenaires
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Partenaire>) => {
        this.paginatedListPartenaires.items = this.paginatedListPartenaires!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListPartenaires!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListPartenaires.hasNextPage = response.hasNextPage
        this.paginatedListPartenaires.hasPreviousPage = response.hasPreviousPage
        this.paginatedListPartenaires.pageIndex = response.pageIndex
        this.paginatedListPartenaires.totalCount = response.totalCount
        this.paginatedListPartenaires.totalPages = response.totalPages
      });
  }

  async loadListFournisseurs(params: any) {
    if (!params || params?.reset) {
      this.paginatedListFournisseurs.items = this.paginatedListFournisseurs?.items.filter(u => this.contrat?.fournisseurId === u.id);
      this.paginatedListFournisseurs.totalCount = this.paginatedListFournisseurs.items.length;
    }

    await this.$http.myressif.fournisseurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Fournisseur>) => {
        this.paginatedListFournisseurs.items = this.paginatedListFournisseurs!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListFournisseurs!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListFournisseurs.hasNextPage = response.hasNextPage
        this.paginatedListFournisseurs.hasPreviousPage = response.hasPreviousPage
        this.paginatedListFournisseurs.pageIndex = response.pageIndex
        this.paginatedListFournisseurs.totalCount = response.totalCount
        this.paginatedListFournisseurs.totalPages = response.totalPages
      });
  }

  async loadOpportunites(params: any) {
    if (!params || params?.reset) {
      this.paginatedListOpportunites.items = this.paginatedListOpportunites?.items.filter(u => this.contrat.opportuniteId === u.id);
      this.paginatedListOpportunites.totalCount = this.paginatedListOpportunites.items.length;
    }

    await this.$http.myressif.entreprises
      .getListOpportunitesByEntrepriseId(
        this.$route.params.id,
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'libelle',
        params?.orderByDescending ?? false
      )
      .then((response: PaginatedList<ShortOpportunite>) => {
        this.paginatedListOpportunites.items = this.paginatedListOpportunites!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListOpportunites!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListOpportunites.hasNextPage = response.hasNextPage
        this.paginatedListOpportunites.hasPreviousPage = response.hasPreviousPage
        this.paginatedListOpportunites.pageIndex = response.pageIndex
        this.paginatedListOpportunites.totalCount = response.totalCount
        this.paginatedListOpportunites.totalPages = response.totalPages
      });
  }

  async loadListContactComptabilite(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsComptabilite.items = this.paginatedListContactsComptabilite?.items.filter(c => this.contrat.contactComptabiliteId === c.id);
      this.paginatedListContactsComptabilite.totalCount = this.paginatedListContactsComptabilite.items.length;
    }

    await this.$http.myressif.entreprises
      .getListContactsByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? ""
      )
      .then((response: PaginatedList<Contact>) => {
        this.paginatedListContactsComptabilite.items = this.paginatedListContactsComptabilite!.items.concat(
          response.items.filter(
            (ri) => !this.paginatedListContactsComptabilite!.items.some((lsi) => lsi.id == ri.id)
          )
        );
        this.paginatedListContactsComptabilite.hasNextPage = response.hasNextPage
        this.paginatedListContactsComptabilite.hasPreviousPage = response.hasPreviousPage
        this.paginatedListContactsComptabilite.pageIndex = response.pageIndex
        this.paginatedListContactsComptabilite.totalCount = response.totalCount
        this.paginatedListContactsComptabilite.totalPages = response.totalPages
      });
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    var response: {code: string, libelle: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }
  
  async loadEcheancierFacturation() {
    this.listEcheancierFacturation = await this.loadParametre('opportunites_echeancier_facturation')
  }

  async loadConditionPaiement() {
    this.listConditionPaiement = await this.loadParametre('opportunites_condition_paiement')
  }

  async loadEntiteFacturation() {
    this.listEntiteFacturation = await this.loadParametre('opportunites_entite_facturation')
  }

  async loadTypePrestation() {
    this.listTypePrestation = await this.loadParametre('opportunites_type_prestation')
  }
}
